import { Turbo } from '@hotwired/turbo-rails'
import * as ActiveStorage from '@rails/activestorage'
import { application } from './controllers'
import { scroll_into_view } from './stream-actions/browser'
import { set_theme } from './stream-actions/dom'
import { turbo_clear_cache } from './stream-actions/turbo'
import 'chartkick/chart.js'
import './basecoat/basecoat.js'
import './basecoat/select.js'
import './basecoat/popover.js'
import './basecoat/dropdown-menu.js'

ActiveStorage.start()

Turbo.config.forms.confirm = (message, _element, submitter) => {
  const defaultDialogIdentifier = 'turbo-confirm-dialog'

  const dialogIdentifier =
    submitter?.dataset.turboConfirmDialogId ||
    submitter?.closest('form')?.dataset.turboConfirmDialogId ||
    defaultDialogIdentifier

  const isCustomDialog = dialogIdentifier !== defaultDialogIdentifier
  const dialog = document.getElementById(dialogIdentifier)

  // Fall back to native confirm if dialog isn't in the DOM
  if (!dialog) return Promise.resolve(confirm(message))

  // Prevents modals etc from closing
  document.addEventListener(
    'keyup',
    e => {
      if (e.key === 'Escape') {
        e.stopPropagation()
      }
    },
    { once: true, capture: true }
  )

  if (!isCustomDialog) {
    const messageElement = document.getElementById('turbo-confirm-message')
    const confirmButton = dialog.querySelector('button[value="confirm"]')

    messageElement.textContent = message

    // Allow custom button text via data-turbo-confirm-button
    const buttonText =
      submitter?.dataset.turboConfirmButton ||
      submitter?.closest('form')?.dataset.turboConfirmButton ||
      'Confirm'

    const isDestructive =
      submitter?.dataset.turboConfirmDestructive === 'true' ||
      submitter?.closest('form')?.dataset.turboConfirmDestructive === 'true'

    confirmButton.textContent = buttonText

    if (isDestructive) {
      confirmButton.classList.remove('btn-primary')
      confirmButton.classList.add('btn-destructive')
    } else {
      confirmButton.classList.remove('btn-destructive')
      confirmButton.classList.add('btn-primary')
    }
  }

  dialog.showModal()

  return new Promise(resolve => {
    dialog.addEventListener(
      'close',
      () => {
        resolve(dialog.returnValue === 'confirm')
      },
      { once: true }
    )
  })
}


Turbo.StreamActions.set_theme = set_theme
Turbo.StreamActions.scroll_into_view = scroll_into_view
Turbo.StreamActions.turbo_clear_cache = turbo_clear_cache

Turbo.StreamActions.close_modal = function() {
  const modal = document.querySelector('[data-controller="turbo-modal"]')
  if (modal) {
    const controller = application?.getControllerForElementAndIdentifier(modal, 'turbo-modal')
    controller?.close()
  }
}

window
  .matchMedia('(prefers-color-scheme: dark)')
  .addEventListener('change', e => {
    const isSystem = document.documentElement.classList.contains('system')
    const wantsDark = e.matches

    if (isSystem) {
      if (wantsDark) {
        document.documentElement.classList.add('dark')
      } else {
        document.documentElement.classList.remove('dark')
      }
    }
  })
